import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_LAB_TESTS } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getLaboratoryTestMeasurementType = createAsyncThunk(
  "labtests/get-laboratory-test-measurement-types",
  async () => {
    try {
      const api = useAxios();
      const response = await api.get(
        URL_LAB_TESTS + "/laboratory-test-measurement-type"
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getLaboratoryTestMeasurementType };
